import SiteLayout from './SiteLayout';
import SEO from '../../components/layout/SEO';
import CrewGrid from '../../components/marketing/CrewGrid';
import VisitSection from '../../components/marketing/VisitSection';
import { useCopy } from '../../content';
import { useShopConfig } from '../../hooks/useShopConfig';

/** About page — content pass §2. */
export default function AboutPage() {
  const c = useCopy().about;
  const { t, shop } = useShopConfig();

  const values = [c.values.craft, c.values.respect, c.values.community];

  return (
    <SiteLayout>
      <SEO title={t(c.hero.headline)} description={t(c.hero.subline)} />

      <section className="max-w-4xl mx-auto px-6 pt-16 pb-12">
        <p className="kd-kicker text-gold-text text-xs uppercase tracking-[0.18em]">{t(c.hero.kicker)}</p>
        <h1 className="font-serif text-navy text-4xl md:text-5xl mt-4 leading-tight">{t(c.hero.headline)}</h1>
        <p className="text-slate-body text-lg mt-4">{t(c.hero.subline)}</p>
      </section>

      <section className="bg-paper border-y border-edge-1">
        <div className="max-w-3xl mx-auto px-6 py-16">
          <h2 className="font-serif text-navy text-3xl">{t(c.story.headline)}</h2>
          {c.story.paragraphs.map((para) => (
            <p key={para.slice(0, 24)} className="text-slate-body mt-5 leading-relaxed">
              {t(para)}
            </p>
          ))}
        </div>
      </section>

      <section className="max-w-6xl mx-auto px-6 py-16">
        <h2 className="font-serif text-navy text-3xl">{t(c.values.headline)}</h2>
        <div className="grid md:grid-cols-3 gap-10 mt-10">
          {values.map((v) => (
            <div key={v.label}>
              <h3 className="font-serif text-navy text-xl">{t(v.label)}</h3>
              <p className="text-slate-body mt-2 leading-relaxed">{t(v.body)}</p>
            </div>
          ))}
        </div>
      </section>

      <CrewGrid variant="bio" />
      <VisitSection />

      <section className="max-w-3xl mx-auto px-6 py-16 text-center">
        <p className="font-serif text-navy text-2xl leading-relaxed">{t(c.comeBy.body)}</p>
        <div className="flex flex-wrap justify-center gap-4 mt-8">
          <a href={shop.bookingUrl} target="_blank" rel="noopener noreferrer" className="bg-navy text-cream px-7 py-3 rounded-pill font-serif shadow-shell">
            {t(c.comeBy.ctaBook)}
          </a>
          <a href={shop.google_maps_url} className="border border-navy text-navy px-7 py-3 rounded-pill font-serif">
            {t(c.comeBy.ctaDirections)}
          </a>
        </div>
      </section>
    </SiteLayout>
  );
}
